export default __webpack_public_path__ + "76ee60630e532f9420cd8ba1e9f519c7.svg";